module.exports = __webpack_public_path__ + "static/media/YF30_2.a3bc5b9e.jpg";